import React from 'react';
import { Collapse, Typography } from 'antd';
import { DailyReportPanel, GroupAnalyticsPanel } from '@/components';

const { Text } = Typography;

/**
 * Daily Report and Group Analytics, each loading only when opened. Open, they run 5 and 7 reports over their own
 * range (30 days by default); with the rest of the page that was ~17 reports at once on the 2-vCPU replica, and on
 * 26 Oct 2026 every one of them ran past the ALB's 60 s and the cards showed "Could not load".
 */
export const ReportGroupPanels: React.FC = () => (
  <Collapse
    style={{ marginTop: 16 }}
    items={[
      {
        key: 'daily-report',
        label: (
          <span>
            Daily Report{' '}
            <Text type="secondary">
              acquisition funnel, abandonment, FTUE drop-off, daily sheet
            </Text>
          </span>
        ),
        children: <DailyReportPanel />,
      },
      {
        key: 'group-analytics',
        label: (
          <span>
            Group Analytics{' '}
            <Text type="secondary">sessions, player groups, mode mix, card drops, AI, LTV</Text>
          </span>
        ),
        children: <GroupAnalyticsPanel />,
      },
    ]}
  />
);
